import React from 'react';
import OriginalPhoneInput, { Props } from 'react-phone-number-input';
import { DefaultInputComponentProps } from 'react-phone-number-input/index';

export const PhoneInput = (props: Props<DefaultInputComponentProps>) => <OriginalPhoneInput {...props} />;
